<template>
  <div class="cpd-content-footer">
      <div class="cpd-footer-title">View another skill</div>
      <div class="cpd-skill-card-container d-flex flex-wrap">
      <template v-for="(skill, dIndex) in this.skills">
        <div
          v-if="skill.value.chapterName !== skillSelected.name"
          :key="'bottom-' + dIndex"
          class="bottom-skill"
        >
          <v-card max-width="148" @click="switchToSection(skill)">
            <div>
              <div class="cpd-skill-card-thumbnail">
                <img :src="skill.value.sectionThumbnail" />
              </div>
              <div class="cpd-skill-card-text">
                <v-card-title class="cpd-skill-card-title">
                  {{skill.value.chapterName}}
                </v-card-title>
              </div>
            </div>
          </v-card>
        </div>
      </template>
      </div>
    </div>
</template>

<script lang="js">
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'BottomCard',
  props: ['skills'],
  methods: {
    ...mapMutations({
      setChapterTitle: 'book/SET_CHAPTER_TITLE',
      setSectionContent: 'book/SET_SECTION_CONTENT',
      setSkillSelected: 'book/SET_SKILL_SELECTED'
    }),
    switchToSection (skill) {
      this.setChapterTitle(skill.value.chapterName)
      this.setSectionContent(skill.value.sectionData)
      this.setSkillSelected(skill)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ...mapState({
      skillSelected: state => state.book.skillSelected
    })
  }
}
</script>

<style lang="scss">
.cpd-content-footer {
  width: 90%;
  margin-top: 40px;
  margin-bottom: 50px;
  @media screen and (max-width: 600px) {
    margin: 20px !important;
  }
  .cpd-footer-title {
    font-weight: 700;
    font-size: 24px;
  }
  .cpd-skill-card-container {
    margin-top: 20px;
    @media screen and (max-width: 600px) {
      justify-content: space-evenly;
    }
    .bottom-skill {
      .v-card {
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
        border-radius: 6px;
        margin-right: 32px;
        margin-top: 12px;
        img {
          max-height: 100%;
          max-width: 100%;
          width: 148px;
        }
        .cpd-skill-card-text {
          .cpd-skill-card-title {
            font-weight: 700;
            font-size: 16px;
            padding: 10px 5px;
            word-break: normal;
            text-align: center;
            line-height: 20px;
            display: block;
          }
        }
      }
    }
  }
}
</style>
